var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("ContentLayout", {
    attrs: {
      title: _vm.$t("label_essweb_punchManage_list_title"),
      pad: "0",
      editBtn: !_vm.iSEdited,
      exportBtn: _vm.hasBtn("export-" + _vm.Permission.permission),
      importBtn: _vm.hasBtn("import-" + _vm.Permission.permission),
      "import-options": {
        api: _vm.Permission.api,
        templateUrl: _vm.Permission.templateUrl,
        success: function (result) {
          _vm.getType()
        },
      },
    },
    on: {
      edit: function ($event) {
        _vm.iSEdited = true
      },
      export: function ($event) {
        return _vm.onExport(_vm.Permission)
      },
    },
    scopedSlots: _vm._u([
      {
        key: "page-main",
        fn: function () {
          return [
            !_vm.criteriaType.length ? _c("noContent") : _vm._e(),
            _c(
              "Taber",
              {
                attrs: {
                  contentBackground: "transparent",
                  curTab: _vm.curTab,
                  items: _vm.taber,
                  special: "",
                  "close-translate": "",
                },
                on: {
                  change: function (tab) {
                    return (_vm.curTab = tab)
                  },
                },
              },
              [
                _vm._l(_vm.criteriaType, function (it, index) {
                  return _c(
                    "template",
                    { slot: "content-" + (index + 1) },
                    [
                      it.punch_code.toLowerCase() == "gps"
                        ? _c("Tabler", {
                            key: "table-" + index,
                            attrs: {
                              headers: _vm.GPSHeader,
                              items: it.criteriaData,
                              totalCount: _vm.totalCount[index],
                              height: _vm.iSEdited
                                ? _vm.$vuetify.breakpoint.height - 335 - 48
                                : _vm.$vuetify.breakpoint.height - 335 - 4,
                              border: "",
                            },
                            on: {
                              change: function (page, perpage, callback) {
                                _vm.getList(
                                  it.punch_code,
                                  index,
                                  page,
                                  perpage,
                                  callback
                                )
                              },
                            },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "item.gps_name",
                                  fn: function (ref) {
                                    var item = ref.item
                                    return [
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "table-title text--primary",
                                        },
                                        [
                                          _vm._v(
                                            " " +
                                              _vm._s(
                                                _vm.$getCommonLangValue(
                                                  item.criteria_gps_name
                                                )
                                              ) +
                                              " "
                                          ),
                                        ]
                                      ),
                                    ]
                                  },
                                },
                                {
                                  key: "item.gps_dis",
                                  fn: function (ref) {
                                    var item = ref.item
                                    return [
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "table-title text--primary",
                                        },
                                        [
                                          _vm._v(
                                            " " +
                                              _vm._s(
                                                item.within_distance_meter
                                              ) +
                                              " "
                                          ),
                                        ]
                                      ),
                                    ]
                                  },
                                },
                                {
                                  key: "item.gps_status",
                                  fn: function (ref) {
                                    var item = ref.item
                                    return [
                                      _c(
                                        "v-chip",
                                        {
                                          staticClass: "white--text",
                                          attrs: {
                                            small: "",
                                            color: item.status
                                              ? "green"
                                              : "grey",
                                          },
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              item.status
                                                ? _vm.$t(
                                                    "label_essweb_system_status_onLabel"
                                                  )
                                                : _vm.$t(
                                                    "label_essweb_system_status_offLabel"
                                                  )
                                            )
                                          ),
                                        ]
                                      ),
                                    ]
                                  },
                                },
                                {
                                  key: "item.action",
                                  fn: function (ref) {
                                    var item = ref.item
                                    return [
                                      _vm.iSEdited &&
                                      _vm.hasBtn(
                                        "edit-admin-admin-clock-in-criteria-gps"
                                      )
                                        ? _c(
                                            "v-btn",
                                            {
                                              attrs: { icon: "" },
                                              on: {
                                                click: function ($event) {
                                                  return _vm.toEdit(
                                                    it.punch_code,
                                                    item.uuid,
                                                    index
                                                  )
                                                },
                                              },
                                            },
                                            [
                                              _c(
                                                "span",
                                                {
                                                  staticClass:
                                                    "material-icons-round",
                                                },
                                                [_vm._v("edit")]
                                              ),
                                            ]
                                          )
                                        : _vm._e(),
                                      _vm.iSEdited &&
                                      _vm.hasBtn(
                                        "delete-admin-admin-clock-in-criteria-gps"
                                      )
                                        ? _c(
                                            "v-btn",
                                            {
                                              attrs: { icon: "" },
                                              on: {
                                                click: function ($event) {
                                                  return _vm.toDelete(
                                                    it.punch_code,
                                                    item.uuid,
                                                    index
                                                  )
                                                },
                                              },
                                            },
                                            [
                                              _c(
                                                "span",
                                                {
                                                  staticClass:
                                                    "material-icons-round",
                                                },
                                                [_vm._v("delete")]
                                              ),
                                            ]
                                          )
                                        : _vm._e(),
                                      !_vm.iSEdited &&
                                      _vm.hasBtn(
                                        "view-admin-admin-clock-in-criteria-gps"
                                      )
                                        ? _c(
                                            "v-btn",
                                            {
                                              attrs: { icon: "" },
                                              on: {
                                                click: function ($event) {
                                                  return _vm.toView(
                                                    it.punch_code,
                                                    item.uuid,
                                                    index
                                                  )
                                                },
                                              },
                                            },
                                            [
                                              _c("svg-icon", {
                                                attrs: {
                                                  size: "24",
                                                  fill: "currentColor",
                                                  iconClass: "viewDetail",
                                                },
                                              }),
                                            ],
                                            1
                                          )
                                        : _vm._e(),
                                    ]
                                  },
                                },
                              ],
                              null,
                              true
                            ),
                          })
                        : _vm._e(),
                      it.punch_code.toLowerCase() == "wifi"
                        ? _c("Tabler", {
                            key: "table-" + index,
                            attrs: {
                              headers: _vm.wifiHeader,
                              totalCount: _vm.totalCount[index],
                              items: it.criteriaData,
                              height: _vm.iSEdited
                                ? _vm.$vuetify.breakpoint.height - 335 - 48
                                : _vm.$vuetify.breakpoint.height - 335 - 4,
                              border: "",
                            },
                            on: {
                              change: function (page, perpage, callback) {
                                _vm.getList(
                                  it.punch_code,
                                  index,
                                  page,
                                  perpage,
                                  callback
                                )
                              },
                            },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "item.wifi_name",
                                  fn: function (ref) {
                                    var item = ref.item
                                    return [
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "table-title text--primary",
                                        },
                                        [
                                          _vm._v(
                                            " " +
                                              _vm._s(
                                                _vm.$getCommonLangValue(
                                                  item.criteria_wifi_name
                                                )
                                              ) +
                                              " "
                                          ),
                                        ]
                                      ),
                                    ]
                                  },
                                },
                                {
                                  key: "item.wifi_ip",
                                  fn: function (ref) {
                                    var item = ref.item
                                    return [
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "table-title text--primary",
                                        },
                                        [_vm._v(_vm._s(item.ssid))]
                                      ),
                                    ]
                                  },
                                },
                                {
                                  key: "item.wifi_site",
                                  fn: function (ref) {
                                    var item = ref.item
                                    return [
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "table-title text--primary",
                                        },
                                        [
                                          _vm._v(
                                            " " +
                                              _vm._s(
                                                _vm.$getCommonLangValue(
                                                  item.site_name
                                                )
                                              ) +
                                              " "
                                          ),
                                        ]
                                      ),
                                    ]
                                  },
                                },
                                {
                                  key: "item.wifi_status",
                                  fn: function (ref) {
                                    var item = ref.item
                                    return [
                                      _c(
                                        "v-chip",
                                        {
                                          staticClass: "white--text",
                                          attrs: {
                                            small: "",
                                            color: item.status
                                              ? "green"
                                              : "grey",
                                          },
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              item.status
                                                ? _vm.$t(
                                                    "label_essweb_system_status_onLabel"
                                                  )
                                                : _vm.$t(
                                                    "label_essweb_system_status_offLabel"
                                                  )
                                            )
                                          ),
                                        ]
                                      ),
                                    ]
                                  },
                                },
                                {
                                  key: "item.action",
                                  fn: function (ref) {
                                    var item = ref.item
                                    return [
                                      _vm.iSEdited &&
                                      _vm.hasBtn(
                                        "edit-admin-admin-clock-in-criteria-wifi"
                                      )
                                        ? _c(
                                            "v-btn",
                                            {
                                              attrs: { icon: "" },
                                              on: {
                                                click: function ($event) {
                                                  return _vm.toEdit(
                                                    it.punch_code,
                                                    item.uuid,
                                                    index
                                                  )
                                                },
                                              },
                                            },
                                            [
                                              _c(
                                                "span",
                                                {
                                                  staticClass:
                                                    "material-icons-round",
                                                },
                                                [_vm._v("edit")]
                                              ),
                                            ]
                                          )
                                        : _vm._e(),
                                      _vm.iSEdited &&
                                      _vm.hasBtn(
                                        "delete-admin-admin-clock-in-criteria-wifi"
                                      )
                                        ? _c(
                                            "v-btn",
                                            {
                                              attrs: { icon: "" },
                                              on: {
                                                click: function ($event) {
                                                  return _vm.toDelete(
                                                    it.punch_code,
                                                    item.uuid,
                                                    index
                                                  )
                                                },
                                              },
                                            },
                                            [
                                              _c(
                                                "span",
                                                {
                                                  staticClass:
                                                    "material-icons-round",
                                                },
                                                [_vm._v("delete")]
                                              ),
                                            ]
                                          )
                                        : _vm._e(),
                                      !_vm.iSEdited &&
                                      _vm.hasBtn(
                                        "view-admin-admin-clock-in-criteria-wifi"
                                      )
                                        ? _c(
                                            "v-btn",
                                            {
                                              attrs: { icon: "" },
                                              on: {
                                                click: function ($event) {
                                                  return _vm.toView(
                                                    it.punch_code,
                                                    item.uuid,
                                                    index
                                                  )
                                                },
                                              },
                                            },
                                            [
                                              _c("svg-icon", {
                                                attrs: {
                                                  size: "24",
                                                  fill: "currentColor",
                                                  iconClass: "viewDetail",
                                                },
                                              }),
                                            ],
                                            1
                                          )
                                        : _vm._e(),
                                    ]
                                  },
                                },
                              ],
                              null,
                              true
                            ),
                          })
                        : _vm._e(),
                      it.punch_code.toLowerCase() == "bluetooth"
                        ? _c("Tabler", {
                            key: "table-" + index,
                            attrs: {
                              headers: _vm.blueToothHeader,
                              totalCount: _vm.totalCount[index],
                              items: it.criteriaData,
                              border: "",
                              height: _vm.iSEdited
                                ? _vm.$vuetify.breakpoint.height - 335 - 48
                                : _vm.$vuetify.breakpoint.height - 335 - 4,
                            },
                            on: {
                              change: function (page, perpage, callback) {
                                _vm.getList(
                                  it.punch_code,
                                  index,
                                  page,
                                  perpage,
                                  callback
                                )
                              },
                            },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "item.bluetooth_name",
                                  fn: function (ref) {
                                    var item = ref.item
                                    return [
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "table-title text--primary",
                                        },
                                        [
                                          _vm._v(
                                            " " +
                                              _vm._s(
                                                _vm.$getCommonLangValue(
                                                  item.criteria_bluetooth_name
                                                )
                                              ) +
                                              " "
                                          ),
                                        ]
                                      ),
                                    ]
                                  },
                                },
                                {
                                  key: "item.bluetooth_site",
                                  fn: function (ref) {
                                    var item = ref.item
                                    return [
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "table-title text--primary",
                                        },
                                        [
                                          _vm._v(
                                            " " +
                                              _vm._s(
                                                _vm.$getCommonLangValue(
                                                  item.site_name
                                                )
                                              ) +
                                              " "
                                          ),
                                        ]
                                      ),
                                    ]
                                  },
                                },
                                {
                                  key: "item.bluetooth_id",
                                  fn: function (ref) {
                                    var item = ref.item
                                    return [
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "table-title text--primary",
                                        },
                                        [
                                          _vm._v(
                                            " " +
                                              _vm._s(
                                                item.bluetooth_device_uuid
                                              ) +
                                              " "
                                          ),
                                        ]
                                      ),
                                    ]
                                  },
                                },
                                {
                                  key: "item.bluetooth_status",
                                  fn: function (ref) {
                                    var item = ref.item
                                    return [
                                      _c(
                                        "v-chip",
                                        {
                                          staticClass: "white--text",
                                          attrs: {
                                            small: "",
                                            color: item.status
                                              ? "green"
                                              : "grey",
                                          },
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              item.status
                                                ? _vm.$t(
                                                    "label_essweb_system_status_onLabel"
                                                  )
                                                : _vm.$t(
                                                    "label_essweb_system_status_offLabel"
                                                  )
                                            )
                                          ),
                                        ]
                                      ),
                                    ]
                                  },
                                },
                                {
                                  key: "item.action",
                                  fn: function (ref) {
                                    var item = ref.item
                                    return [
                                      _vm.iSEdited &&
                                      _vm.hasBtn(
                                        "edit-admin-admin-clock-in-criteria-bluetooth"
                                      )
                                        ? _c(
                                            "v-btn",
                                            {
                                              attrs: { icon: "" },
                                              on: {
                                                click: function ($event) {
                                                  return _vm.toEdit(
                                                    it.punch_code,
                                                    item.uuid,
                                                    index
                                                  )
                                                },
                                              },
                                            },
                                            [
                                              _c(
                                                "span",
                                                {
                                                  staticClass:
                                                    "material-icons-round",
                                                },
                                                [_vm._v("edit")]
                                              ),
                                            ]
                                          )
                                        : _vm._e(),
                                      _vm.iSEdited &&
                                      _vm.hasBtn(
                                        "delete-admin-admin-clock-in-criteria-bluetooth"
                                      )
                                        ? _c(
                                            "v-btn",
                                            {
                                              attrs: { icon: "" },
                                              on: {
                                                click: function ($event) {
                                                  return _vm.toDelete(
                                                    it.punch_code,
                                                    item.uuid,
                                                    index
                                                  )
                                                },
                                              },
                                            },
                                            [
                                              _c(
                                                "span",
                                                {
                                                  staticClass:
                                                    "material-icons-round",
                                                },
                                                [_vm._v("delete")]
                                              ),
                                            ]
                                          )
                                        : _vm._e(),
                                      !_vm.iSEdited &&
                                      _vm.hasBtn(
                                        "view-admin-admin-clock-in-criteria-bluetooth"
                                      )
                                        ? _c(
                                            "v-btn",
                                            {
                                              attrs: { icon: "" },
                                              on: {
                                                click: function ($event) {
                                                  return _vm.toView(
                                                    it.punch_code,
                                                    item.uuid,
                                                    index
                                                  )
                                                },
                                              },
                                            },
                                            [
                                              _c("svg-icon", {
                                                attrs: {
                                                  size: "24",
                                                  fill: "currentColor",
                                                  iconClass: "viewDetail",
                                                },
                                              }),
                                            ],
                                            1
                                          )
                                        : _vm._e(),
                                    ]
                                  },
                                },
                              ],
                              null,
                              true
                            ),
                          })
                        : _vm._e(),
                      it.punch_code.toLowerCase() == "gps"
                        ? _c(
                            "v-container",
                            {
                              key: "tabletools-" + index,
                              staticClass: "pa-0",
                              attrs: { fluid: "" },
                            },
                            [
                              _vm.iSEdited &&
                              _vm.hasBtn(
                                "add-admin-admin-clock-in-criteria-gps"
                              )
                                ? _c(
                                    "v-btn",
                                    {
                                      staticClass: "mt-2 text-capitalize",
                                      attrs: { text: "", color: "primary" },
                                      on: {
                                        click: function ($event) {
                                          return _vm.toNew(it.punch_code, index)
                                        },
                                      },
                                    },
                                    [
                                      _vm._v(
                                        " " +
                                          _vm._s(
                                            _vm.$t(
                                              "label_essweb_punchManage_list_addCriteriaBtnLabel"
                                            )
                                          ) +
                                          " "
                                      ),
                                      _c(
                                        "span",
                                        { staticClass: "material-icons-round" },
                                        [_vm._v("add")]
                                      ),
                                    ]
                                  )
                                : _vm._e(),
                            ],
                            1
                          )
                        : _vm._e(),
                      it.punch_code.toLowerCase() == "wifi"
                        ? _c(
                            "v-container",
                            {
                              key: "tabletools-" + index,
                              staticClass: "pa-0",
                              attrs: { fluid: "" },
                            },
                            [
                              _vm.iSEdited ? _c("v-divider") : _vm._e(),
                              _vm.iSEdited &&
                              _vm.hasBtn(
                                "add-admin-admin-clock-in-criteria-wifi"
                              )
                                ? _c(
                                    "v-btn",
                                    {
                                      staticClass: "mt-2 text-button",
                                      attrs: { text: "", color: "primary" },
                                      on: {
                                        click: function ($event) {
                                          return _vm.toNew(it.punch_code, index)
                                        },
                                      },
                                    },
                                    [
                                      _vm._v(
                                        " " +
                                          _vm._s(
                                            _vm.$t(
                                              "label_essweb_punchManage_list_addCriteriaBtnLabel"
                                            )
                                          ) +
                                          " "
                                      ),
                                      _c(
                                        "span",
                                        { staticClass: "material-icons-round" },
                                        [_vm._v("add")]
                                      ),
                                    ]
                                  )
                                : _vm._e(),
                            ],
                            1
                          )
                        : _vm._e(),
                      it.punch_code.toLowerCase() == "bluetooth"
                        ? _c(
                            "v-container",
                            {
                              key: "tabletools-" + index,
                              staticClass: "pa-0",
                              attrs: { fluid: "" },
                            },
                            [
                              _vm.iSEdited &&
                              _vm.hasBtn(
                                "add-admin-admin-clock-in-criteria-bluetooth"
                              )
                                ? _c(
                                    "v-btn",
                                    {
                                      staticClass: "mt-2 text-capitalize",
                                      attrs: { text: "", color: "primary" },
                                      on: {
                                        click: function ($event) {
                                          return _vm.toNew(it.punch_code, index)
                                        },
                                      },
                                    },
                                    [
                                      _vm._v(
                                        " " +
                                          _vm._s(
                                            _vm.$t(
                                              "label_essweb_punchManage_list_addCriteriaBtnLabel"
                                            )
                                          ) +
                                          " "
                                      ),
                                      _c(
                                        "span",
                                        { staticClass: "material-icons-round" },
                                        [_vm._v("add")]
                                      ),
                                    ]
                                  )
                                : _vm._e(),
                            ],
                            1
                          )
                        : _vm._e(),
                    ],
                    1
                  )
                }),
              ],
              2
            ),
          ]
        },
        proxy: true,
      },
      {
        key: "tools-main",
        fn: function () {
          return [
            _c("newGps", {
              attrs: { show: _vm.showNewGps },
              on: {
                close: function ($event) {
                  _vm.showNewGps = false
                },
                onNew: _vm.onNew,
              },
            }),
            _c("newWifi", {
              attrs: { show: _vm.showNewWifi },
              on: {
                close: function ($event) {
                  _vm.showNewWifi = false
                },
                onNew: _vm.onNew,
              },
            }),
            _c("newBluetooth", {
              attrs: { show: _vm.showNewBluetooth },
              on: {
                close: function ($event) {
                  _vm.showNewBluetooth = false
                },
                onNew: _vm.onNew,
              },
            }),
            _c("editBluetooth", {
              attrs: {
                show: _vm.showEditBluetooth,
                curUuid: _vm.curBluetoothUuid,
              },
              on: {
                close: function ($event) {
                  _vm.showEditBluetooth = false
                  _vm.curBluetoothUuid = null
                },
                onEdit: _vm.onEdit,
              },
            }),
            _c("viewBluetooth", {
              attrs: {
                show: _vm.showViewBluetooth,
                curUuid: _vm.curBluetoothUuid,
              },
              on: {
                close: function ($event) {
                  _vm.showViewBluetooth = false
                  _vm.curBluetoothUuid = null
                },
                onEdit: _vm.onEdit,
              },
            }),
            _c("editWifi", {
              attrs: { show: _vm.showEditWifi, curUuid: _vm.curWifiUuid },
              on: {
                close: function ($event) {
                  _vm.showEditWifi = false
                  _vm.curWifiUuid = null
                },
                onEdit: _vm.onEdit,
              },
            }),
            _c("viewWifi", {
              attrs: { show: _vm.showViewWifi, curUuid: _vm.curWifiUuid },
              on: {
                close: function ($event) {
                  _vm.showViewWifi = false
                  _vm.curWifiUuid = null
                },
                onEdit: _vm.onEdit,
              },
            }),
            _c("editGps", {
              attrs: { show: _vm.showEditGps, curUuid: _vm.curGpsUuid },
              on: {
                close: function ($event) {
                  _vm.showEditGps = false
                  _vm.curGpsUuid = null
                },
                onEdit: _vm.onEdit,
              },
            }),
            _c("viewGps", {
              attrs: { show: _vm.showViewGps, curUuid: _vm.curGpsUuid },
              on: {
                close: function ($event) {
                  _vm.showViewGps = false
                  _vm.curGpsUuid = null
                },
                onEdit: _vm.onEdit,
              },
            }),
          ]
        },
        proxy: true,
      },
    ]),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }